<ion-app class="synairg-container application__language--{{ $activeLanguage | async }}">
  <ion-router-outlet> </ion-router-outlet>
</ion-app>
<div class="info">
  <app-mobile-available-screen></app-mobile-available-screen>
</div>
<app-garmin-guide></app-garmin-guide>
<!-- test -->